import i18n from "@/utils/i18n";
import Control from "ol/control/Control";

type SpeedValue = 0.5 | 1 | 2;

export class SpeedControl extends Control {
	constructor({
		onSpeedChange,
		defaultSpeed,
	}: {
		onSpeedChange: (speed: SpeedValue) => void;
		defaultSpeed: number;
	}) {
		const container = document.createElement("div");
		container.className = "ol-control ol-unselectable speed-control";

		const label = document.createElement("p");
		label.textContent = i18n.t("speed");

		container.append(label);

		const createSpeedBtn = (value: SpeedValue) => {
			const label = document.createElement("label");
			label.className = "speed-label";
			label.textContent = `x${value}`;

			const btn = document.createElement("input");
			btn.type = "radio";
			btn.name = i18n.t("speed");
			btn.className = "speed-btn";
			btn.checked = value === defaultSpeed;
			btn.id = `speed-${value}`;
			btn.value = value.toString();
			btn.dataset.speed = value.toString();

			label.htmlFor = btn.id;

			btn.addEventListener("change", () => {
				if (btn.checked) {
					onSpeedChange(value);
				}
			});

			const wrapper = document.createElement("div");
			wrapper.appendChild(btn);
			wrapper.appendChild(label);

			return wrapper;
		};

		container.append(createSpeedBtn(0.5), createSpeedBtn(1), createSpeedBtn(2));

		super({ element: container });
	}
}
